import React from "react";
import { useTranslation } from "src/hooks";

function LabelValuePair({
  label,
  value,
}: {
  label: string;
  value?: React.ReactNode;
}) {
  const { t } = useTranslation("assetManagement");

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(200px, max-content) 1fr",
        gap: "8px",
      }}
    >
      <div>{t(label)}</div>
      <div>{value}</div>
    </div>
  );
}

export default LabelValuePair;
